import { defineMessages } from 'react-intl';

export default defineMessages({
  courtManagerRecapTitle: {
    id: 'court_manager_legal_proceedings_page.recap_tab.title',
  },
  courtManagerJudgementAddTitle: {
    id: 'court_manager_legal_proceedings_page.judgement_add_tab.title',
  },
  courtManagerJudgementValidate: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.validate',
  },
  courtManagerJudgementReject: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.reject',
  },
  courtManagerJudgementDecisionCancel: {
    id: 'legal_proceeding_page.validation_buttons.back',
  },
  courtManagerJudgementDecision: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.decision',
  },
  courtManagerJudgementRefuse: {
    id: 'court_manager_legal_proceedings_page.procedure_decision.refuse',
  },
  courtManagerConfirmationDialogTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.title',
  },
  courtManagerConfirmationDialogConfirm: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.confirm',
  },
  courtManagerConfirmationDialogCancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.cancel',
  },
  courtManagerConfirmationDialogContent: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.content_message',
  },
  courtManagerConfirmationOnRejectionTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_on_rejection_dialog.content_message',
  },
  courtManagerRejectionTitleDialog: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.rejection_dialog.content_message',
  },
  courtManagerUpdateDialogContent: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.update_dialog.content_message',
  },
  courtManagerRefuseDialogTitle: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.title',
  },
  courtManagerRefusalDialogReasonLabel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.reason',
  },
  courtManagerRefusalDialogReasonValidate: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.validate',
  },
  courtManagerRefusalDialogReasonCancel: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.cancel',
  },
  courtManagerRefusalDialogSuccessMessage: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.refusal_popin.success_message',
  },
  courtManagerValidationDialogSuccessMessage: {
    id:
      'court_manager_legal_proceedings_page.judgement_add.confirmation_dialog.success_message',
  },
  courtManagerPronouncingUpdateDialogSuccessMessage: {
    id: 'pronouncing_judgement_add_update.success',
  },
  courtManagerUpdateDialogSuccessMessage: {
    id: 'judgement_add_update.success',
  },
  courtManagerValidationTitle: {
    id: 'manage_claim.judgement_add.validation',
  },
  courtManagerValidationJomTitle: {
    id: 'manage_claim.expert_report.validation',
  },
  courtManagerValidationAlertVictim: {
    id: 'manage_claim.expert_report.validation_victim',
  },
  courtManagerValidationAlertVehicle: {
    id: 'manage_claim.expert_report.validation_vehicle',
  },
  have: {
    id: 'have',
  },
  has: {
    id: 'has',
  },
  jom: { id: 'legal_proceeding_page.judgement_on_merits_tab_title' },
  expertReport: { id: 'fee_note.expert_report' },
  supportDocument: {
    id:
      'legal_proceeding_page.judgement_add.civil_party.civil_party_recap.support_document',
  },
  updateIncomeCertificateSucess: {
    id:
      'legal_proceeding_page.judgement_add.income_certificate.update_toast_success',
  },
  validationToastSuccess: {
    id:
      'legal_proceeding_page.judgement_add.income_certificate.validation_toast_success',
  },
  decisionTitle: {
    id: 'recap_page.update.btn_decision',
  },
  reason: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_merits.contestation_drawer_withdrawal_reason',
  },
  dialogValidationButton: {
    id: 'assignment_dialog.validation_button',
  },
  dialogCancelButton: {
    id: 'assignment_dialog.cancel_button',
  },
});
